<div>
  <ul *ngIf="pageTitle">
    <li *ngFor="let previousPage of previousPages">
      {{ previousPage?.title }}
    </li>
    <li>{{ pageTitle }}</li>
  </ul>

  <div *ngIf="lastPage && lastPage.url">
    <a [routerLink]="lastPage?.url"
      ><riv-icon [name]="'ArrowLeftCircle'" [size]="16"></riv-icon>
      <div>Back to {{ customBackButtonTitle || lastPage?.title }}</div>
    </a>
  </div>
  <div *ngIf="lastPage && !lastPage.url">
    <a (click)="backButtonClick.emit()"
      ><riv-icon [name]="'ArrowLeftCircle'" [size]="16"></riv-icon>
      <div>Back to {{ customBackButtonTitle || lastPage?.title }}</div></a
    >
  </div>
</div>
